const runHtml = require("./runHtml");

/**
 * @param data {Data}
 */
module.exports = function thenAddUuidInputToAllFormsOnThePage(data) {
  document.querySelectorAll(`form`).forEach((form) => {
    let input = form.querySelector('[name="uUID"]');
    if (!input) {
      input = runHtml(
        `<input name="uUID" type="hidden" style="display: none">`,
      );
      form.append(input);
    }

    input.value = data.userUuid;
  });
};
